import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { debounceTime, filter, map, Subject, takeUntil } from 'rxjs';
import { App_FormFieldCheckbox, App_TrueField } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-checkbox',
  templateUrl: './c-checkbox.component.html',
  styleUrls: ['./c-checkbox.component.scss'],
})
export class CCheckboxComponent implements OnInit, OnDestroy {
  @Input({ required: true }) field!: App_FormFieldCheckbox;
  @Input({ required: true }) cFormControl!: FormControl;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) disabledField!: boolean;
  @Input({ required: false }) noLabel: true | undefined;
  @Input({ required: false }) looksDisabled!: true | undefined;
  @Input() etatId?: number;
  @Output() triggerAlert = new EventEmitter<{
    blocName: string;
    fieldName: string;
    fieldFormControl: AbstractControl<any, any>;
    field: App_TrueField;
  }>();

  destroyComponent$: Subject<boolean> = new Subject();

  constructor() { }

  ngOnInit() {
    this.addAlertSubscriptions();
  }

  ngOnDestroy() {
    this.destroyComponent$.next(true);
  }

  addAlertSubscriptions() {
    const checkValidity = this.field.checkValidity;
    if (checkValidity !== undefined) {
      const validators = Array.isArray(checkValidity.validators)
      ? checkValidity.validators
      : [];
      const asyncValidators = Array.isArray(checkValidity.asyncValidators)
      ? checkValidity.asyncValidators
      : [];
      const allValidators = [
        ...validators,
        ...asyncValidators
      ];
      const validatorsWithTriggerAlert = allValidators.filter(validator => validator.triggerAlert);
      if (validatorsWithTriggerAlert.length > 0) {
        this.cFormControl.statusChanges.pipe(
          takeUntil(this.destroyComponent$),          
          debounceTime(200),
          filter(status => status === 'INVALID'),
          map(_ => {
            const errors = this.cFormControl.errors;
            if (errors !== null && (validatorsWithTriggerAlert.find(validator => errors[validator.type]) || (errors['err'] !== undefined && errors['err'][`type`] !== undefined && validatorsWithTriggerAlert.find(validator => errors['err'][`type`] === validator.type)))) {
              return errors;
            }
            return null;
          }),
          filter(_ => _ !== null),
        ).subscribe(errors => {
          this.triggerAlert.emit({
            blocName: this.blocName,
            fieldName: this.field.name,
            fieldFormControl: this.cFormControl,
            field: this.field,
          });
        })
      }
    }
  }

}
